import request from '@/sheep/request';

const VisitApi = {

	// 获取访客记录列表
	getVisitorList: (params: any) => {
		return request({
			url: '/wish/visit/who-visit-me',
			method: 'GET',
			data: params,
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},

	// 记录访问（访问他人主页时调用）
	recordVisit: (targetUserId : number) => {
		const type = 1
		return request({
			url: '/wish/visit/record',
			method: 'POST',
			data: { targetUserId, type },
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},
};

export default VisitApi;